module.exports = __webpack_public_path__ + "static/img/brees-2017-slide-5.9a9b10d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2017-slide-5.jpg
// module id = 1FtH
// module chunks = 1